export var ExtrasId = function (ExtrasId) {
  ExtrasId["EARLY_CHECK_IN"] = "HSCKIN";
  ExtrasId["LATE_CHECK_OUT"] = "HSCOU2";
  ExtrasId["ULTIMATE_WIFI"] = "FI24HR";
  ExtrasId["BOTTLE_OF_PROSECCO"] = "DBPROS";
  ExtrasId["ULTIMATE_WIFI_FREE"] = "FIFR24";
  ExtrasId["EARLY_CHECK_IN_FREE"] = "HSCKIF";
  ExtrasId["LATE_CHECK_OUT_FREE"] = "FHSCOU2";
  return ExtrasId;
}({});